module.exports = __webpack_public_path__ + "img/80.23d3bfd8.jpg";